@if (isLoading()) {
<div class="loader-overlay">
  <div class="spinner">
    <img [src]="s3BucketAssets() + '/global/web/common/loader.gif'" alt="loader" />
  </div>
</div>
}
